<template>
  <!-- 账号密码截图 -->
  <div class="page_win">
    <div class="topContent">
      <div class="topContent_l" @click="closeWin" v-if="$store.state.winType.isCouponFrom=='pay'">
        <img :src="back" />
      </div>
      <div class="topContent_m">
        <span>我的优惠卷列表</span>
      </div>
      <div class="closeBtn" @click="closeWin">
        <img :src="closeImg" />
      </div>
    </div>
    <div class="rowsContent">
      <div class="couponItem" v-for="(item,index) of couponInfoList" :key="index" v-show="couponInfoList.length>0">
        <div class="couponValueDiv">
          <div class="couponValueShow">￥{{ item.couponValue }}</div>
          <div class="condition">{{ item.condition }}</div>
        </div>
        <div class="validityDateDiv">
          <div class="validityName">{{ item.couponName }}</div>
          <div class="useValue">使用范围：{{ item.useValue }}</div>
          <div class="validityDate">有效期至：{{ item.validityDate }}</div>
        </div>
        <div class="checkBtn"  v-if="$store.state.winType.isCouponFrom=='pay'" @click="checkCoupon(item)">
            <span>使用</span>
          </div>
      </div>

      <div
        class="content"
        v-if="couponInfoList.lenght<1"
      >
        <p class="content_row">暂无更多优惠卷信息</p>
      </div>
    </div>
    <div class="more">
      <img class="tip_icon" :src="tip_icon" alt="" @click="checkTip" />
      <div class="more_text">
        <img class="down_icon" :src="down_icon" alt="" />
        <span>滑动查看更多内容</span>
      </div>
      <div class="couponTip" v-if="isShowTip">
        <img class="couponTip_bg" :src="couponTip_bg" alt="">
        <div class="couponTip_text">
          <span>代金券金额抵扣最低只可减至1元整！</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fun from "@/common/js/common";
export default {
  props: ["isShowContact", "isCloseBtn"],
  inject: ["reload"],
  props:['couponData'],
  data() {
    return {
      showInfo: "",
      userInfo: "",
      adid: "",
      couponInfoList:[],
      back: require("../../assets/img/view10/back.png"), // 关闭
      closeImg: require("../../assets/img/view10/close.png"), // 关闭
      down_icon: require("../../assets/img/view10/down_icon.png"), // 关闭
      tip_icon: require("../../assets/img/view10/tip.png"), // 关闭
      couponTip_bg: require("../../assets/img/view10/couponTip_bg.png"),
      isShowTip:false
    };
  },
  creater() {},
  mounted() {
    this.showInfo = JSON.parse(localStorage.getItem("showInfo"));
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.adid = localStorage.getItem("adid");
    if(this.couponData){
      this.couponInfoList=this.couponData;
    }else{
      this.couponList();
    }
  },
  methods: {
    checkTip(){
      this.isShowTip = !this.isShowTip;
    },
    // 关闭当前窗口
    closeWin: function () {
      this.$store.dispatch("IsCouponInfoFun", false);
      this.$store.dispatch("IsCouponFromFun", "mask");
    },
    //选择代金券
    checkCoupon(item){
      if(this.$store.state.winType.isCouponFrom=='pay'){
        this.$emit("toChenckCoupon",JSON.stringify(item));
        this.$store.dispatch("IsCouponInfoFun", false);
        this.$store.dispatch("IsCouponFromFun", "mask");
      }
    },
    //获取优惠卷列表信息
    couponList() {
      let data = {
        adId: this.adid,
        memberId: this.userInfo.uid,
        token: this.userInfo.token,
      };
      this.$http.post(fun.apiUrl + "api/coupon/list/have", data).then(
        function (res) {
          this.couponInfoList = res.data.data;
          console.log(res);
        },
        function (res) {}
      );
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
::-webkit-input-placeholder {
  color: #bcbcbc;
}
::-moz-placeholder {
  color: #bcbcbc;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #bcbcbc;
} /* ie */
input:-moz-placeholder {
  color: #bcbcbc;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.couponItem{
  padding:.12rem 0 .1rem .16rem ;
  @include flex_box(row, space-between, stretch);
  border-bottom: 1px solid #e6e6e6;
  font-size: 12px;
}
.couponValueDiv{
  width: 25%;
  @include flex_box(column, center, flex-start);
}
.validityDateDiv{
  flex: 1;
  @include flex_box(column, center, flex-start);
  color: #b8b8b8;
  font-size: 12px
}

.closeBtn,
.topContent_m,
.topContent_l {
  @include flex_box(row, center, center);
  font-size: 0.28rem;
}
.closeBtn,
.topContent_l {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.8rem;
  height: 0.68rem;
  justify-content: flex-end;
  img {
    width: 0.3rem;
  }
}
.topContent_l{
  left:0;
  justify-content: flex-start;
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    line-height: 0.68rem;
  }
}

.rowsContent {
  flex:1;
  margin-top: .1rem;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  color: #12CDB0;
  &::-webkit-scrollbar {
    display: none;
  }
  height:auto;
}
.couponValueShow {
  font-weight: 800;
  text-align: left;
  font-size: 0.42rem;
}
.validityName,
.condition,
.useValue{
  line-height: 16px;
}
.checkBtn{
  @include flex_box(row, center, center);
  width:1.1rem;
  min-width:1.1rem;
  height: .4rem;
  border-radius: .1rem;
  background-color: #12CDB0;
  color: #fff;
}
.more{
    padding: 0 .32rem;
    box-sizing: border-box;
    margin-top: .4rem;
    position: relative;
  }
  .tip_icon{
    width: .42rem;
    height: .42rem;
  }
  .more,.more_text{
    
    @include flex_box(row, space-between, center);
    color: #12CDB0;
  }
  .more_text{
    flex: 1;
    justify-content: center;
  }
  .down_icon{
    margin-right: .12rem;
    width: .3rem;
  }
  .couponTip{
    position: absolute;
    left: 50%;
    margin-left: -1.8rem;
    top: -.52rem;
    width: 3.86rem;
    @include flex_box(row, center, center);
  }
  .couponTip_bg{
    width:3.86rem;
    height: auto;
  }
  .couponTip_text{
    @include flex_box(row, center, center);
    width: 100%;
    height: 100%;
    position: absolute;
    padding-left: .1rem;
    box-sizing: border-box;
    left: 0;
    right:0;
    span{
      width: 120%;
      font-size: 12px;
      transform: scale(.8);
      transform-origin: center center;
      color: #fff;
      white-space: nowrap;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/view10/coupon.vue